import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/administration/organizations/")({
  beforeLoad: () => {
    throw redirect({ to: "/workspace/organizations" });
  },
});
